export default "__VITE_ASSET__D5K23mrO__"